import React from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody, InputGroup, InputGroupAddon, Input, UncontrolledTooltip } from 'reactstrap';
import copy from 'copy-to-clipboard';
import CopyIcon from '@mui/icons-material/FileCopy';

class DocumentLinkExpired extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            share_link: '',
            error_message: ''
        }
    }

    componentDidMount = () => {
        this.setState({
            loading: true
        })

        fetch(window.location.protocol + '//' + window.location.host + '/api/archive/get_document_share_link?id=' + this.props.file._id)
            .then(res => res.json())
            .then((result) => {
                if (result.link)
                    this.setState({
                        loading: false,
                        share_link: result.link
                    })
            })
            .catch(error => {
                console.error(error)
                this.setState({
                    loading: false,
                    error_message: error.message
                })
            });
    }

    copyText = () => {
        copy(this.state.share_link);
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle}>
                    <ModalHeader>{'Share Link: ' + this.props.file.DocumentRef}</ModalHeader>
                    <ModalBody>
                        <ModalBody>
                            <InputGroup style={{ alignContent: 'center', display: 'inline-flex' }}>
                                <Input placeholder="Share Link ..." value={this.state.share_link} contentEditable={false} />
                                <InputGroupAddon addonType="append">
                                    <UncontrolledTooltip placement="bottom" hideArrow={true} target="copyTextButton" trigger="click">
                                        <p>Link Copied!</p>
                                    </UncontrolledTooltip>
                                    <Button color="primary" onClick={this.copyText} disabled={this.state.loading} id="copyTextButton">
                                        <CopyIcon fontSize={'small'} />
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </ModalBody>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.props.toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default (DocumentLinkExpired);